import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "../lib/api";
import LeadForm from "../components/LeadForm";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPost(null);
    setNotFound(false);
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center bg-[#0B132B]" data-testid="post-not-found">
        <div className="text-center">
          <h1 className="font-display text-4xl font-bold text-white mb-4">Article Not Found</h1>
          <Link to="/blog" className="text-[#F97316] text-sm font-semibold">← Back to Trucking Insights</Link>
        </div>
      </div>
    );
  }

  if (!post) return <div className="min-h-[60vh] bg-[#0B132B]" data-testid="post-loading" />;

  return (
    <div className="bg-[#0B132B]" data-testid="blog-post-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <Link to="/blog" data-testid="back-to-blog"
          className="inline-flex items-center gap-1.5 text-xs text-slate-400 hover:text-[#F97316] mb-8 transition-colors">
          <ArrowLeft className="w-3.5 h-3.5" /> Trucking Insights
        </Link>
        <p className="font-mono2 text-xs text-slate-500 uppercase tracking-wider mb-3">
          {new Date(post.created_at).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
        </p>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black text-white tracking-tight leading-tight mb-8" data-testid="post-title">
          {post.title}
        </h1>
        {post.cover_image && (
          <img src={post.cover_image} alt={post.title} data-testid="post-cover"
            className="w-full h-64 sm:h-96 object-cover rounded-lg border border-[#1E293B] mb-10" />
        )}
        <div className="space-y-5" data-testid="post-content">
          {post.content.split(/\n+/).filter(Boolean).map((para, i) => (
            <p key={i} className="text-slate-300 text-sm sm:text-base leading-relaxed">{para}</p>
          ))}
        </div>
        <div className="mt-14 bg-[#131C38] border border-[#1E293B] rounded-lg p-7 sm:p-9">
          <LeadForm title="Questions About Your Filing?" />
        </div>
      </div>
    </div>
  );
}
